module.exports = __webpack_public_path__ + "static/media/backWave11.962f241e.svg";